import React from 'react';
import Slider from 'react-slick';
import 'theme/vendor/slick.min.scss';
import './Carousel.scss';
const Carousel = React.forwardRef((props, ref) => {
    const { carouselHtmlData, carouselConfig, carouselStyle = '' } = props;
    const config = {
        infinite: true,
        pauseOnHover: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000
    };
    Object.assign(config, carouselConfig);
    return (
        <div style={{ width: '100%' }} className={`slider-main carousel-comp-slider ${carouselStyle}`}>
            <Slider {...config} ref={ref}>
                {
                    carouselHtmlData.map(data => {
                        return data;
                    })
                }
            </Slider>
        </div>
    );
});

export default Carousel;
